<template>
    <button
            :class="['btn btn-middle', {disabled: !authorities.includes('ROLE_SUBSCRIBED_USER')}]"
            type="button"
            @click="clickBtn"
            :title="!authorities.includes('ROLE_SUBSCRIBED_USER') ? 'Доступно при наличии платной подписки' : ''"
    >
        <img src="../../assets/img/ico-filter-plus-white.svg" alt="">
        <span>Создать фильтр</span>
    </button>
</template>

<script>
    import {mapGetters, mapActions } from "vuex";
    import { showSubscriptionToast } from "@/services/subscriptionNotification";

    export default {
        name: "PurchasesTableCustomFilterBtn",
        computed: {
            ...mapGetters('auth', ['authorities']),
            ...mapGetters('profile', ['profileId']),
            ...mapGetters('subscriptions', ['subscriptions']),
        },
        methods: {
            ...mapActions('subscriptions', ['getSubscriptions']),
            async clickBtn() {
                await this.getSubscriptions(this.profileId);

                if (this.authorities.includes('ROLE_SUBSCRIBED_USER')) {
                    this.$emit('clickBtn')
                    return
                }

                showSubscriptionToast(this.subscriptions, this.$toast);

                this.$emit('clickBtn')
            },
        }
    }
</script>

<style lang="less" scoped>
    button {
        cursor: pointer !important;
        padding: 0 20px;

        img {
            display: block;
            margin-right: 8px;
        }
    }
</style>
